<template>
	<div class="item__wrap position-rel text-center">
		<div class="item__head">
			<a href="javascript:;" @click="directDetailPage">
				<img class="inner-img" v-lazy="itemBook.imageUrl !== null ? replaceLink(itemBook.imageUrl) : ''" :alt="itemBook.name" />
				<!-- <img class="inner-img" :src="itemBook.imageUrl !== null ? replaceLink(itemBook.imageUrl) : ''" :alt="itemBook.name" /> -->
			</a>
		</div>
		<div class="item__body">
			<h3 class="item__name font-size-18 font-sanpro-semibold primary-color-txt">
				<a href="javascript:;" @click="directDetailPage" class="primary-color-txt">
					{{ itemBook.name }}
				</a>
			</h3>
			<p class="margin-0 secondary-color-txt font-size-14">Năm xuất bản: {{ itemBook.manufactureYear }}</p>
		</div>
	</div>
</template>

<script>
	// import { APP_CONFIG } from '@/utils/constants'
	import { replaceImageResize } from '@/helpers/functions'

	export default {
		name: 'ItemBook',
		props: {
			itemBook: Object,
      		preview: Boolean
		},
		data() {
			return {
				// cdnLive: APP_CONFIG.cdnLive
			};
		},
		methods: {
			directDetailPage() {
        		!this.preview && this.$router.push({ name: 'ebook-detail', params: { id: this.itemBook.bookId, slug: this.itemBook.slug } })
			},

			replaceLink (link) {
				return replaceImageResize(link, {width: 285, height: 404})
			}
		}
	};
</script>

<style lang="css" scoped>
</style>